export const isEqualDates = function (date1: Date, date2: Date) {
  return (
    date1.getDate() == date2.getDate() &&
    date1.getFullYear() == date2.getFullYear() &&
    date1.getMonth() == date2.getMonth()
  );
};

export const isFirstDateBigger = function (date1: Date, date2: Date) {
  return (
    date1.getFullYear() > date2.getFullYear() ||
    date1.getMonth() > date2.getMonth() ||
    date1.getDate() > date2.getDate()
  );
};
